module.exports = __webpack_public_path__ + "img/unconfirm_tag.c228c9df.png";